var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "console-faq",
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "max-width": "1280px",
      "width": "100%"
    }
  }, [_c('v-row', {
    staticClass: "mt-8",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pt-0 pb-0 headline text-start",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("FAQ")]), _c('v-spacer'), _c('v-col', {
    staticClass: "pt-0 pb-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "secondary",
      "rounded": ""
    },
    on: {
      "click": function click($event) {
        _vm.showSearch = !_vm.showSearch;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-filter-variant")]), _vm._v("검색필터")], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "elevation-1 mt-4",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.faqs,
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.createdAt",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.createdAt.toDate()) + " ")];
      }
    }, {
      key: "item.faq",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-row', {
          on: {
            "click": function click($event) {
              return _vm.$set(item, 'show', !item.show);
            }
          }
        }, [_c('v-col', {
          staticClass: "text-start",
          attrs: {
            "cols": "auto"
          }
        }, [_vm._v("[" + _vm._s(item.type) + "] " + _vm._s(item.subject))]), _c('v-spacer'), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [!item.show ? _c('v-icon', [_vm._v("mdi-chevron-down")]) : _c('v-icon', [_vm._v("mdi-chevron-up")])], 1)], 1), _c('v-expand-transition', [_c('v-row', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: item.show,
            expression: "item.show"
          }]
        }, [_c('v-col', {
          staticClass: "text-start",
          attrs: {
            "cols": "12"
          }
        }, [_c('p', {
          domProps: {
            "innerHTML": _vm._s(item.content.replace(/\n/g, '<br>'))
          }
        })])], 1)], 1)];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v(" mdi-pencil ")]), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v(" mdi-delete ")])];
      }
    }], null, true)
  }), _c('v-pagination', {
    staticClass: "mt-4 mb-12",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }), _c('v-dialog', {
    attrs: {
      "max-width": "800px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref4) {
        var on = _ref4.on;
        return [_c('v-btn', {
          attrs: {
            "bottom": "",
            "color": "accent",
            "dark": "",
            "fab": "",
            "fixed": "",
            "right": ""
          },
          on: {
            "click": _vm.create
          }
        }, [_c('v-icon', _vm._g({}, on), [_vm._v("mdi-pencil")])], 1)];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_vm.dialog ? _c('v-card', [_c('v-card-title', [!_vm.editItem._id ? _c('span', {
    staticClass: "subtitle-1"
  }, [_vm._v("FAQ 등록")]) : _c('span', {
    staticClass: "subtitle-1"
  }, [_vm._v("수정")])]), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "제목",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "subject", $$v);
      },
      expression: "editItem.subject"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "순서",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.sequence,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "sequence", $$v);
      },
      expression: "editItem.sequence"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-select', {
    staticClass: "mt-4",
    attrs: {
      "items": _vm.typeItems,
      "label": "유형",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.type,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "type", $$v);
      },
      expression: "editItem.type"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-select', {
    staticClass: "mt-4",
    attrs: {
      "items": _vm.locales,
      "item-text": "text",
      "item-value": "value",
      "label": "언어",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.locale,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "locale", $$v);
      },
      expression: "editItem.locale"
    }
  })], 1)], 1), _c('div', {
    staticClass: "caption mt-4 mb-1"
  }, [_vm._v("내용")]), _c('naver-smarteditor', {
    model: {
      value: _vm.editItem.content,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "content", $$v);
      },
      expression: "editItem.content"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }